/* eslint-disable */
import _m0 from 'protobufjs/minimal';

export const protobufPackage = 'payments.v1';

export interface BankAccount {
  firstName: string;
  lastName: string;
  iban: string;
  bic: string;
}

export interface BankPaymentMethod {
  /** Can be null when the user didn't save any bank account details yet */
  bankAccount: BankAccount | undefined;
}

export interface RecurringPaymentMethod {
  id: string;
  type?: {$case: 'bankPaymentMethod'; bankPaymentMethod: BankPaymentMethod};
}

const baseBankAccount: object = {
  firstName: '',
  lastName: '',
  iban: '',
  bic: '',
};

export const BankAccount = {
  encode(
    message: BankAccount,
    writer: _m0.Writer = _m0.Writer.create(),
  ): _m0.Writer {
    if (message.firstName !== '') {
      writer.uint32(10).string(message.firstName);
    }
    if (message.lastName !== '') {
      writer.uint32(18).string(message.lastName);
    }
    if (message.iban !== '') {
      writer.uint32(26).string(message.iban);
    }
    if (message.bic !== '') {
      writer.uint32(34).string(message.bic);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): BankAccount {
    const reader = input instanceof Uint8Array ? new _m0.Reader(input) : input;
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = {...baseBankAccount} as BankAccount;
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.firstName = reader.string();
          break;
        case 2:
          message.lastName = reader.string();
          break;
        case 3:
          message.iban = reader.string();
          break;
        case 4:
          message.bic = reader.string();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): BankAccount {
    const message = {...baseBankAccount} as BankAccount;
    if (object.firstName !== undefined && object.firstName !== null) {
      message.firstName = String(object.firstName);
    }
    if (object.lastName !== undefined && object.lastName !== null) {
      message.lastName = String(object.lastName);
    }
    if (object.iban !== undefined && object.iban !== null) {
      message.iban = String(object.iban);
    }
    if (object.bic !== undefined && object.bic !== null) {
      message.bic = String(object.bic);
    }
    return message;
  },

  toJSON(message: BankAccount): unknown {
    const obj: any = {};
    message.firstName !== undefined && (obj.firstName = message.firstName);
    message.lastName !== undefined && (obj.lastName = message.lastName);
    message.iban !== undefined && (obj.iban = message.iban);
    message.bic !== undefined && (obj.bic = message.bic);
    return obj;
  },

  fromPartial(object: DeepPartial<BankAccount>): BankAccount {
    const message = {...baseBankAccount} as BankAccount;
    if (object.firstName !== undefined && object.firstName !== null) {
      message.firstName = object.firstName;
    }
    if (object.lastName !== undefined && object.lastName !== null) {
      message.lastName = object.lastName;
    }
    if (object.iban !== undefined && object.iban !== null) {
      message.iban = object.iban;
    }
    if (object.bic !== undefined && object.bic !== null) {
      message.bic = object.bic;
    }
    return message;
  },
};

const baseBankPaymentMethod: object = {};

export const BankPaymentMethod = {
  encode(
    message: BankPaymentMethod,
    writer: _m0.Writer = _m0.Writer.create(),
  ): _m0.Writer {
    if (message.bankAccount !== undefined) {
      BankAccount.encode(
        message.bankAccount,
        writer.uint32(10).fork(),
      ).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): BankPaymentMethod {
    const reader = input instanceof Uint8Array ? new _m0.Reader(input) : input;
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = {...baseBankPaymentMethod} as BankPaymentMethod;
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.bankAccount = BankAccount.decode(reader, reader.uint32());
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): BankPaymentMethod {
    const message = {...baseBankPaymentMethod} as BankPaymentMethod;
    if (object.bankAccount !== undefined && object.bankAccount !== null) {
      message.bankAccount = BankAccount.fromJSON(object.bankAccount);
    }
    return message;
  },

  toJSON(message: BankPaymentMethod): unknown {
    const obj: any = {};
    message.bankAccount !== undefined &&
      (obj.bankAccount = message.bankAccount
        ? BankAccount.toJSON(message.bankAccount)
        : undefined);
    return obj;
  },

  fromPartial(object: DeepPartial<BankPaymentMethod>): BankPaymentMethod {
    const message = {...baseBankPaymentMethod} as BankPaymentMethod;
    if (object.bankAccount !== undefined && object.bankAccount !== null) {
      message.bankAccount = BankAccount.fromPartial(object.bankAccount);
    }
    return message;
  },
};

const baseRecurringPaymentMethod: object = {id: ''};

export const RecurringPaymentMethod = {
  encode(
    message: RecurringPaymentMethod,
    writer: _m0.Writer = _m0.Writer.create(),
  ): _m0.Writer {
    if (message.id !== '') {
      writer.uint32(10).string(message.id);
    }
    if (message.type?.$case === 'bankPaymentMethod') {
      BankPaymentMethod.encode(
        message.type.bankPaymentMethod,
        writer.uint32(18).fork(),
      ).ldelim();
    }
    return writer;
  },

  decode(
    input: _m0.Reader | Uint8Array,
    length?: number,
  ): RecurringPaymentMethod {
    const reader = input instanceof Uint8Array ? new _m0.Reader(input) : input;
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = {...baseRecurringPaymentMethod} as RecurringPaymentMethod;
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.id = reader.string();
          break;
        case 2:
          message.type = {
            $case: 'bankPaymentMethod',
            bankPaymentMethod: BankPaymentMethod.decode(
              reader,
              reader.uint32(),
            ),
          };
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): RecurringPaymentMethod {
    const message = {...baseRecurringPaymentMethod} as RecurringPaymentMethod;
    if (object.id !== undefined && object.id !== null) {
      message.id = String(object.id);
    }
    if (
      object.bankPaymentMethod !== undefined &&
      object.bankPaymentMethod !== null
    ) {
      message.type = {
        $case: 'bankPaymentMethod',
        bankPaymentMethod: BankPaymentMethod.fromJSON(object.bankPaymentMethod),
      };
    }
    return message;
  },

  toJSON(message: RecurringPaymentMethod): unknown {
    const obj: any = {};
    message.id !== undefined && (obj.id = message.id);
    message.type?.$case === 'bankPaymentMethod' &&
      (obj.bankPaymentMethod = message.type?.bankPaymentMethod
        ? BankPaymentMethod.toJSON(message.type?.bankPaymentMethod)
        : undefined);
    return obj;
  },

  fromPartial(
    object: DeepPartial<RecurringPaymentMethod>,
  ): RecurringPaymentMethod {
    const message = {...baseRecurringPaymentMethod} as RecurringPaymentMethod;
    if (object.id !== undefined && object.id !== null) {
      message.id = object.id;
    }
    if (
      object.type?.$case === 'bankPaymentMethod' &&
      object.type?.bankPaymentMethod !== undefined &&
      object.type?.bankPaymentMethod !== null
    ) {
      message.type = {
        $case: 'bankPaymentMethod',
        bankPaymentMethod: BankPaymentMethod.fromPartial(
          object.type.bankPaymentMethod,
        ),
      };
    }
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | undefined;
export type DeepPartial<T> = T extends Builtin
  ? T
  : T extends Array<infer U>
  ? Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U>
  ? ReadonlyArray<DeepPartial<U>>
  : T extends {$case: string}
  ? {[K in keyof Omit<T, '$case'>]?: DeepPartial<T[K]>} & {$case: T['$case']}
  : T extends {}
  ? {[K in keyof T]?: DeepPartial<T[K]>}
  : Partial<T>;
